import { Typography } from '@material-ui/core';
import { styled } from '@material-ui/core/styles';

export const StandardTypography = styled(Typography)(({ theme }) => ({
	fontFamily: 'OpenSauceOneBold',
}));
